import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { TopoPagina } from '../componentes';
import FormFiltroLogRpa from './FormFiltroLogRpa';
import { Skeleton, Button, Table, Drawer, notification } from 'antd';
import { tableLocale } from '../../common/configConstants';
import moment from 'moment';

export class AcompanhamentoLogRpa extends Component {
  static propTypes = {
    logsSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      drawerVisible: false,
    };
  }

  componentDidMount() {
    const { actions } = this.props;

    actions.listarLogsRpa({
      where: {
        TipoLog: 'Erro',
        DataLog: {
          gte: moment(moment(moment().add(-7, 'days')).startOf('day')).add(-3, 'hours') 
        }
      },
      order: 'DataLog desc',
      include: ['AgendamentoRPA']
    });
    
    actions.listarAgendamentoRpa();
  }

  componentDidUpdate(prevProps) {
    const { logsSistema } = this.props;

    if (prevProps.logsSistema.listarLogsRpaPending && !logsSistema.listarLogsRpaPending) {
      if (logsSistema.listarLogsRpaError) {
        notification.error({ message: 'Falha ao buscar registros.' });
      }

      this.setState({ drawerVisible: false });
    }
  }


  render() {
    const { logsSistema } = this.props;
    const { drawerVisible } = this.state;

    const colunas = [
      {
        title: 'Rotina RPA',
        dataIndex: 'AgendamentoRPA.Nome',
        key: 'AgendamentoRPA.Nome',
      },
      {
        title: 'Tipo Log',
        dataIndex: 'TipoLog',
        key: 'TipoLog',
      },
      {
        title: 'Mensagem',
        dataIndex: 'Mensagem',
        key: 'Mensagem',
      },
      {
        title: 'Data Log',
        dataIndex: 'DataLog',
        key: 'DataLog',
        render: (value) => moment(value).format('DD/MM/YYYY HH:mm:ss')
        // render: (value) => moment(moment(value).add(-3, 'hours')).format('DD/MM/YYYY HH:mm:ss')
      }
    ];

    return (
      <div className="logs-sistema-acompanhamento-log-rpa">
        <Skeleton
          active
          loading={logsSistema.listarLogsRpaPending}
        >
          <TopoPagina titulo="Registros de Log Processamento RPA" >
            <Button onClick={() => this.setState({ drawerVisible: true })} type="primary" icon="search">
              Pesquisar
            </Button>
          </TopoPagina>
          <div className="containerPage" >
            <div className="containerConteudo">
              <Table
                dataSource={logsSistema.listaLogsRpa}
                columns={colunas}
                size="small"
                bordered
                style={{ paddingTop: '15px' }}
                loading={logsSistema.listarLogsRpaPending}
                locale={tableLocale}
              />
            </div>
          </div>
        </Skeleton>

        <Drawer 
          title="Pesquisa de Logs Processamento RPA"
          visible={drawerVisible}
          closable={true}
          onClose={() => this.setState({ drawerVisible: false })}
          destroyOnClose={true}
          width={600}
        >
          <FormFiltroLogRpa />
        </Drawer>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    logsSistema: state.logsSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AcompanhamentoLogRpa);



// WEBPACK FOOTER //
// ./src/features/logs-sistema/AcompanhamentoLogRpa.js